import { defineMessages } from "react-intl";

export const messages = defineMessages({
  checkoutLimits: {
    id: "8uo4v1",
    defaultMessage: "Checkout limits",
    description: "title",
  },
  checkoutLineLimit: {
    id: "C7I2lg",
    defaultMessage: "Limit quantity per checkout (optional)",
    description: "input label",
  },
  checkoutLimitsDescription: {
    id: "n3+6w5",
    defaultMessage:
      "Your customer won't be allowed to buy bigger quantity per checkout than shown here.",
    description: "input helper text",
  },
});
